export { default } from "./ResourcePageDetailsCompleted";
